import { PredictionLabelType } from '@modules/feedback/types';
import { sortBy } from 'lodash';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { getLabelTypeFromPredictionType } from './getLabelTypeFromPredictionType';

interface GetFeedbackLabelsToDisplayOptions {
  labels: FeedbackLabel[];
  selectedLabels: FeedbackLabel[];
  shouldSortBySelection: boolean;
}

export const getFeedbackLabelsToDisplay = ({
  labels,
  selectedLabels,
  shouldSortBySelection,
}: GetFeedbackLabelsToDisplayOptions) => {
  const visibleLabels = labels.filter((label) => label.isVisible);

  if (!shouldSortBySelection || !selectedLabels.length) {
    return sortBy(visibleLabels, ['sentiment', 'displayName']);
  }

  const feedbackLabelsID = labels.map((label) => label.id);
  const selectedLabelsForCategory = selectedLabels.filter((label) =>
    feedbackLabelsID.includes(label.id),
  );
  const selectedLabelsForType = selectedLabelsForCategory.filter(
    (label) =>
      label.type ===
        getLabelTypeFromPredictionType(PredictionLabelType.Entity) ||
      getLabelTypeFromPredictionType(PredictionLabelType.Reason),
  );

  const nonSelectedLabels = visibleLabels.filter((label) => {
    return selectedLabelsForType.indexOf(label) === -1;
  });

  return [...selectedLabelsForType, ...nonSelectedLabels];
};
